import { useEffect, useState } from "react";

export const TypewriterHeading = ({
  text,
  speed = 80,
  className = "",
  onDone,
  showLine = true,
  testid,
}) => {
  const [typed, setTyped] = useState("");
  const [done, setDone] = useState(false);
  const [lineDrawn, setLineDrawn] = useState(false);
  const [caretLive, setCaretLive] = useState(true);

  useEffect(() => {
    let i = 0;
    const id = setInterval(() => {
      i++;
      setTyped(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(id);
        // blink caret twice (1s) then disappear
        setTimeout(() => {
          setCaretLive(false);
          setDone(true);
          if (showLine) setTimeout(() => setLineDrawn(true), 100);
          onDone && onDone();
        }, 1000);
      }
    }, speed);
    return () => clearInterval(id);
  }, [text, speed, showLine, onDone]);

  return (
    <div className={`wc-heading text-white ${className}`} data-testid={testid || "typewriter"}>
      <span>{typed}</span>
      {!done && <span className={`wc-caret ${caretLive ? "wc-caret-live" : ""}`}>&nbsp;</span>}
      {showLine && lineDrawn && (
        <div className="mt-4 md:mt-6 h-[2px] bg-white w-full wc-line-draw" />
      )}
    </div>
  );
};

export default TypewriterHeading;
